import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Orderss from './components/Orderss';

const orderss = (props,{ t }) => (
  <Container>
    <Orderss {...props} />
  </Container>
);

orderss.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(orderss);
